import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./vendorDetailsPage.css";
import Dialog from "@mui/material/Dialog";
import serviceFieldsConfig from "./serviceFieldsConfig";
import StarRating from "./StarRating";
import { ShowAllUsers } from "../../../context/Slice/RegisterSlice";
import { useDispatch, useSelector } from "react-redux";
import ImagePopup from "../../../utils/imagePopup";

const BackEnd_URL = process.env.REACT_APP_BASE_URL;

const VendorDetails = () => {
  const { id } = useParams(); // Extract vendor ID from URL
  const location = useLocation();
  const [vendor, setVendor] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [userRating, setuserRating] = useState(0);
  const [filteredUser, setFilteredUser] = useState([]);
  const [vendorId, setVendorId]=useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    vendor_Id : ""
  });

  const allUsers = useSelector((state) => state.RegisterR.AlluserData);

  const Role = localStorage.getItem("role");
  const userId = localStorage.getItem("userId");
  console.log(Role, userId);

  useEffect(() => {
    if (Role === "USER") {
      dispatch(ShowAllUsers());
    }
  }, [dispatch]);

  useEffect(() => {
    if (userId && allUsers?.length > 0) {
      const filtered = allUsers.filter((data) => data.id === userId);
      setFilteredUser(filtered);
      console.log("Filtered User:", filtered);
    }
  }, [allUsers, userId]);

  useEffect(() => {
    if (filteredUser.length > 0) {
      setFormData({
        name: filteredUser[0].firstName || "",
        email: filteredUser[0].email || "",
        phone: filteredUser[0].mobile_number || "",
        vendor_Id: vendorId
      });
    }
  }, [filteredUser]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };


  console.log()
  useEffect(() => {
    const fetchVendorDetails = async () => {
      try {
        setLoading(true);
        console.log(`Fetching vendor details for ID: ${id}`);

        // ✅ Get ServiceCategory_ID from localStorage
        const serviceCategoryId = localStorage.getItem("ServiceCategory_ID");
        console.log(`Using ServiceCategory_ID: ${serviceCategoryId}`);

        // ✅ Updated API URL with ServiceCategory_ID
        const response = await axios.get(
          `${BackEnd_URL}/api/v1/VendorManagement/show-Vendor-Service/${id}?ServiceCategory_ID=${serviceCategoryId}`
        );

        console.log("Vendor Details API Response:", response.data);

        if (response.data?.status === "SUCCESS") {
          const vendorData = response.data.data.VendorServices[0]; // Assuming VendorServices is an array

          // ✅ Parse BannerImage if it's a string
          if (
            vendorData.BannerImage &&
            typeof vendorData.BannerImage === "string"
          ) {
            vendorData.BannerImage = JSON.parse(vendorData.BannerImage);
          }

          // ✅ Parse image if it's a string
          if (vendorData.Image && typeof vendorData.Image === "string") {
            vendorData.Image = JSON.parse(vendorData.Image);
          }

          setVendor(vendorData);
          setError(null);
        } else {
          setError("Failed to fetch vendor details.");
        }
      } catch (err) {
        console.error("Error fetching vendor details:", err);
        setError("An error occurred while fetching vendor details.");
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchVendorDetails();
    }
  }, [id]);

  const renderCategoryFields = () => {
    if (!vendor) {
      return <p>No vendor data available.</p>;
    }
  
    const formatDynamicData = (data) => {
      if (typeof data === "string") {
        try {
          data = JSON.parse(data); // Parse if it's a stringified JSON
        } catch (error) {
          console.error("Error parsing DynamicData:", error);
          return "Invalid Data Format";
        }
      }
  
      if (typeof data === "object" && data !== null) {
        return Object.entries(data).map(([key, value]) => {
          if (Array.isArray(value)) {
            return (
              <div key={key}>
                <strong>{key}:</strong> {value.map((v) => v.trim()).join(", ")}
              </div>
            );
          }
          return (
            <div key={key}>
              <strong>{key}:</strong> {value}
            </div>
          );
        });
      }
      return "N/A";
    };
  
    const fieldsToDisplay = [
      { label: "Service Name", value: vendor.ServiceName },
      // Conditionally include Total Budget only for non-VENUE & non-WEDDING CATERERS
      ...(vendor.ServiceName === "VENUE" || vendor.ServiceName === "WEDDING CATERERS"
        ? []
        : [{ label: "Total Budget", value: vendor.TotalBudget }]),
      {
        label: "Service Locations",
        value: JSON.parse(vendor.ServiceLocations).join(", "),
      },
      {
        label: "Service provided by the vendor",
        value: formatDynamicData(vendor.DynamicData),
      },
    ];
  
    return fieldsToDisplay.map((field, index) => (
      <div key={index} className="field-name">
        <label>{field.label}:</label>
        <div className="field-value">
          {Array.isArray(field.value) ? field.value : field.value || "N/A"}
        </div>
      </div>
    ));
  };
  
  // const handleFormSubmit = (e) => {
  //   e.preventDefault();
  
  //   // Collect form data
  //   const formData = new FormData(e.target);
  
  //   if (selectedDate) {
  //     formData.append("date", selectedDate.toISOString()); // Ensure date is included if selected
  //   }
  
  //   // Convert FormData to a JavaScript object
  //   const payload = Object.fromEntries(formData.entries());

  //   const updatedpayload = {...payload, vendor_Id: vendorId}
  
  //   console.log("Payload Preview:", updatedpayload);
  
  //   // Simulate API call or further actions
  //   setShowPopup(true); // Show the popup on form submission
  // };


const handleFormSubmit = async (e) => {
  e.preventDefault();

  // Collect form data
  const formData = new FormData(e.target);

  if (selectedDate) {
    formData.append("date", selectedDate.toISOString()); // Ensure date is included if selected
  }

  // Convert FormData to a JavaScript object
  const payload = Object.fromEntries(formData.entries());

  // Add vendor ID to the payload
  const updatedPayload = { ...payload, vendor_Id: vendorId };

  console.log("Payload Preview:", updatedPayload);

  try {
    const response = await axios.post(
      `${BackEnd_URL}/api/v1/User/Vendor-Enquiry-Form`,
      updatedPayload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    console.log("Form submitted successfully:", response.data);

    // Show the popup after successful submission
    setShowPopup(true);
  } catch (error) {
    console.error("Error submitting form:", error);
    alert("Failed to submit the form. Please try again.");
  }
};

  

  const handleClosePopup = () => {
    setShowPopup(false); // Close the popup
  };

  console.log("Vendor data:", vendor); // Log the vendor data to check its state
  useEffect(() => {
    if (vendor) {
      setVendorId(vendor.Vendor_ID);
    }
  }, [vendor]);
  
console.log(vendorId)
  return (
    <div className="vendor-details-page">
      {/* Banner Section */}
      <div className="vendor-banner">
        {vendor ? (
        <img
        src={
          vendor.BannerImage?.length
            ? `${BackEnd_URL}${(
                typeof vendor.BannerImage[0] === "string"
                  ? vendor.BannerImage[0] // Already a URL string
                  : vendor.BannerImage[0].path // Extract 'path' from object
              )
                .replace("/home/ubuntu/new/CEP_BackEnd", "") // Remove this path if present
                .replace("/home/CEP_BackEnd", "") // Remove this path if present
                .replace(/([^:])\/\//g, "$1/")}` // Fix double slashes
            : "https://via.placeholder.com/1200x300?text=No+Image+Available"
        }
        
        alt={vendor.CompanyName || "Vendor"}
      />
      
       
        ) : (
          <p>Loading banner...</p> // Fallback when vendor data is not available
        )}
      </div>
      <div style={{ textAlign: "center", margin: "10px 0" }}>
        <h1 className="company-title">
          {vendor?.CompanyName || "Vendor Name"}
        </h1>
      </div>
      <div className="rating-title">
        <h2>
          {vendor?.Rating || "⭐5.0"}
          <div className="enquiry-title">
            <h2>{vendor?.EnquiryCount || "(50 reviews)"}</h2>
          </div>
        </h2>
      </div>

      {/* Content Section */}
      <div className="vendor-content">
        {/* Left Section */}
        <div className="vendor-details-section">
          {/* <div className="details-card">
            <h3 className="contact-title">Contact Information</h3>
            {vendor?.firstName && vendor?.lastName && (
              <p>
                <strong>Vendor Name:</strong>{" "}
                {vendor.firstName + " " + vendor.lastName}
              </p>
            )}
            {vendor?.email && (
              <p>
                <strong>Email:</strong> {vendor.email}
              </p>
            )}
            {vendor?.contactNumber && (
              <p>
                <strong>Phone:</strong> {vendor.contactNumber}
              </p>
            )}
            {vendor?.website && (
              <p>
                <strong>Website:</strong>{" "}
                <a
                  href={`https://${vendor.website}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {vendor.website}
                </a>
              </p>
            )}
          </div> */}
          <div className="details-card">
            <h3 className="about-title">About the Vendor</h3>
            <p
              dangerouslySetInnerHTML={{
                __html: vendor?.ServiceDescription || "N/A",
              }}
            />
            <span>
              <p>
                <strong>Rating:</strong>
              </p>
              <StarRating
                maxRating={5}
                size={20}
                onStarRating={setuserRating}
              />
            </span>
          </div>
          <div className="details-card">
            <h3 className="category-title">Category Details</h3>
            {renderCategoryFields()}
          </div>

          <div className="details-card">
            <h2 className="gallery-title">Gallery</h2>
            <div className="gallery">
              <div className="gallery-section">
                {/* Image Grid */}
                <h3 className="gallery-title">Images</h3>
                <div className="gallery-grid">
                {Array.isArray(vendor?.Image) && vendor.Image.length > 0 ? (
  vendor.Image.map((img, index) => {
    const processedPath = img.path
      ?.replace("/home/ubuntu/new/CEP_BackEnd", "") // Remove specific server path
      .replace("/home/CEP_BackEnd", "") // Remove alternative server path
      .replace(/([^:])\/\//g, "$1/"); // Fix double slashes if any

    console.log(`Processed Path [${index}]:`, processedPath);

    const imageSrc = processedPath
      ? `${BackEnd_URL}${processedPath}`
      : "https://via.placeholder.com/150?text=Image+Not+Available";

    console.log(`Final Image Source [${index}]:`, imageSrc);

    return (
      <div className="gallery-item" key={index}>
        <img
          src={imageSrc}
          alt={`Gallery ${index + 1}`}
          style={{
            width: "100%",
            height: "150px",
            objectFit: "cover",
            cursor: "pointer",
            borderRadius: "8px",
          }}
          onClick={() => setSelectedImage(imageSrc)}
        />
      </div>
    );
  })
) : (
  <p>No images available.</p>
)}

                </div>

                {/* Video Grid */}
                <h3 className="gallery-title">Videos</h3>
                <div className="video-grid">
                {vendor?.Video ? (
  (() => {
    try {
      console.log("Raw Video Data:", vendor.Video);

      // ✅ Handle if video is already a URL
      if (typeof vendor.Video === "string" && vendor.Video.startsWith("http")) {
        console.log("Video is already a URL:", vendor.Video);
        return (
          <div className="video-item">
            <video
              controls
              style={{
                width: "100%",
                height: "150px",
                borderRadius: "8px",
              }}
            >
              <source src={vendor.Video} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        );
      }

      // ✅ Parse JSON if video is a stringified object
      const videoData =
        typeof vendor.Video === "string" ? JSON.parse(vendor.Video) : vendor.Video;

      console.log("Parsed Video Data:", videoData);

      // ✅ Ensure videoData is an object and path exists
      if (!videoData || !videoData.path) {
        console.warn("Video data is missing path.");
        return <p>Video not available.</p>;
      }

      // ✅ Fix the path by removing server-specific directory
      const processedVideoPath = videoData.path
        .replace("/home/ubuntu/new/CEP_BackEnd", "") // Remove specific backend path
        .replace("/home/CEP_BackEnd", "") // Remove alternative backend path
        .replace(/([^:])\/\//g, "$1/"); // Fix double slashes

      console.log("Processed Video Path:", processedVideoPath);

      const videoSrc = processedVideoPath ? `${BackEnd_URL}${processedVideoPath}` : "";

      return videoSrc ? (
        <div className="video-item">
          <video
            controls
            style={{
              width: "100%",
              height: "150px",
              borderRadius: "8px",
            }}
          >
            <source src={videoSrc} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      ) : (
        <p>Video not available.</p>
      );
    } catch (error) {
      console.error("Error parsing video data:", error);
      return <p>Invalid video data.</p>;
    }
  })()
) : (
  <p>No videos available.</p>
)}

                </div>
              </div>
            </div>

            {/* Image Preview Dialog */}
            {selectedImage && (
                    <ImagePopup selectedImage={selectedImage} onClose={() => setSelectedImage(null)} />

            )}
          </div>
        </div>

        {/* Right Sidebar */}
        <div className="vendor-sidebar">
          <h3 className="contact-title">Plan. Celebrate. Enjoy!</h3>
          <form className="contact-form" onSubmit={handleFormSubmit}>
            {filteredUser.length > 0 ? (
              filteredUser.map((data, index) => (
                <>
                  {" "}
                  <div className="form-group" key={index} >
                    <label htmlFor="name">Name</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      placeholder="Enter your name"
                      required
                      value={formData.name}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      placeholder="Enter your email"
                      required
                      value={formData.email}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="phone">Phone Number</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      placeholder="Enter your phone number"
                      required
                      value={formData.phone}
                      onChange={handleInputChange}
                    />
                  </div>
                </>
              ))
            ) : (
              <>
                {" "}
                <div className="form-group">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Enter your name"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Enter your email"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    placeholder="Enter your phone number"
                    required
                  />
                </div>
              </>
            )}

            {/* <div className="form-group">
              <label htmlFor="date">Select Date</label>
              <DatePicker
                selected={selectedDate}
                onChange={(date) => setSelectedDate(date)}
                minDate={new Date()} // Disable past dates
                placeholderText="Select a date"
                required
              />
            </div> */}
            <button type="submit" className="btn btn-primary">
              Request Quote
            </button>
          </form>
        </div>
      </div>

      {/* Popup */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <p>Thanks for reaching us, we'll update as soon as possible!</p>
            <button className="popup-close-btn" onClick={handleClosePopup}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default VendorDetails;
